import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import format from 'date-fns/format';

import { Spacer, TextButton } from '@zillow/constellation';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import appLogger from 'app/shared/loggers/appLogger';
import NotificationConstants from 'app/shared/constants/NotificationConstants';
import PostingActions from 'app/shared/actions/PostingActions';
import PropertiesActions from 'app/shared/actions/PropertiesActions';

import { StyledRenewContainer, StyledBlockText } from './StyledComponents';

const { GA_EVENTS } = AnalyticsConstants;
const { track } = analyticsUtils;

const propTypes = {
    formData: PropTypes.object.isRequired,
    updateStatusMessage: PropTypes.func.isRequired,
    setSuccessfulRenewalData: PropTypes.func.isRequired,
    setFailedRenewalData: PropTypes.func.isRequired,
};

const RenewListing = ({
    formData,
    updateStatusMessage,
    setSuccessfulRenewalData,
    setFailedRenewalData,
}) => {
    const dispatch = useDispatch();

    const { aliasEncoded, paidInclusion, listingAlias } = formData;
    const { isEnabled: isListingInNucleusMarket, isPaymentRequired } = paidInclusion || {};
    const isFreeListing = !isPaymentRequired;

    const extendListing = () => {
        updateStatusMessage('Renewing listing...');

        return dispatch(PostingActions.property.activate(listingAlias, true))
            .then(({ response: { expirationDate } }) => {
                const formattedExpirationDate = format(new Date(expirationDate), 'MMM D, YYYY');
                const GALabel = { label: aliasEncoded };

                setSuccessfulRenewalData(formattedExpirationDate);
                dispatch(PropertiesActions.updateCurrentProperty({ expirationDate: formattedExpirationDate }));
                updateStatusMessage('Listing renewed!', NotificationConstants.SUCCESS);

                if (isListingInNucleusMarket === false) {
                    dispatch(track.GAEventV2(GA_EVENTS.EXTEND_LISTING_NON_NUCLEUS_MARKET, GALabel));
                } else if (isListingInNucleusMarket && isFreeListing) {
                    dispatch(track.GAEventV2(GA_EVENTS.EXTEND_LISTING_FREE_NUCLEUS_MARKET, GALabel));
                }
            })
            .catch((errorRMWModel) => {
                setFailedRenewalData(errorRMWModel.message);
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'renewListing.extendListing',
                });
            });
    };

    return (
        <StyledRenewContainer className="RenewListing">
            <StyledBlockText>
                Still looking for a renter?
            </StyledBlockText>
            <Spacer marginLeft="xs" as="span">
                <TextButton
                    fontType="body"
                    onClick={extendListing}
                >
                    Renew listing for 30 days
                </TextButton>
            </Spacer>
        </StyledRenewContainer>
    );
};

RenewListing.propTypes = propTypes;

export default RenewListing;
